import api, { buildQueryString } from "./client";

// API 엔드포인트 상수
const API_ENDPOINT_PREFIX = "/api/v1/users";

// 사용자 관리 API
export const userAPI = {
  getMyPreferences: async (config = {}) => {
    const response = await api.get(`${API_ENDPOINT_PREFIX}/my-preferences`, config);
    return response.data;
  },

  updateMyPreferences: async (preferences, config = {}) => {
    const response = await api.put(
      `${API_ENDPOINT_PREFIX}/my-preferences`,
      preferences,
      config
    );
    return response.data;
  },

  getMyProfile: async (config = {}) => {
    const response = await api.get(`${API_ENDPOINT_PREFIX}/my-profile`, config);
    return response.data;
  },

  updateMyProfile: async (profile, config = {}) => {
    const response = await api.put(
      `${API_ENDPOINT_PREFIX}/my-profile`,
      profile,
      config
    );
    return response.data;
  },

  changeMyPassword: async (passwords, config = {}) => {
    const response = await api.patch(
      `${API_ENDPOINT_PREFIX}/my-password`,
      passwords,
      config
    );
    return response.data;
  },

  // 사용자 목록 조회
  getUsers: async ({ params = {}, config = {} } = {}) => {
    try {
      // 공통 함수를 사용하여 쿼리 문자열 생성
      const queryString = buildQueryString(params);
      const url = `${API_ENDPOINT_PREFIX}${queryString}`;

      const response = await api.get(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 상세 조회
  getUser: async (userId) => {
    try {
      const response = await api.get(`${API_ENDPOINT_PREFIX}/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 생성
  createUser: async (userData) => {
    try {
      const response = await api.post(API_ENDPOINT_PREFIX, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  // 사용자 복제
  copyUser: async (userData) => {
    try {
      const response = await api.post(
        `${API_ENDPOINT_PREFIX}/copy-settings`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 수정
  updateUser: async (userId, userData) => {
    try {
      const response = await api.put(
        `${API_ENDPOINT_PREFIX}/${userId}`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 부분 수정
  patchUser: async (userId, userData) => {
    try {
      const response = await api.patch(
        `${API_ENDPOINT_PREFIX}/${userId}`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 삭제
  deleteUser: async (userId, { config = {} } = {}) => {
    try {
      const response = await api.delete(
        `${API_ENDPOINT_PREFIX}/${userId}`,
        config
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 비밀번호 변경
  changePassword: async (userId, passwordData) => {
    try {
      const response = await api.post(
        `${API_ENDPOINT_PREFIX}/${userId}/password`,
        passwordData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 상태 변경 (활성화/비활성화)
  changeUserStatus: async (userId, status) => {
    try {
      const response = await api.patch(
        `${API_ENDPOINT_PREFIX}/${userId}/status`,
        {
          status,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 역할 변경
  changeUserRole: async (userId, role) => {
    try {
      const response = await api.patch(
        `${API_ENDPOINT_PREFIX}/${userId}/role`,
        {
          role,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 검색
  searchUsers: async (searchParams) => {
    try {
      const queryString = buildQueryString(searchParams);
      const url = `${API_ENDPOINT_PREFIX}/search${queryString}`;

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 권한 조회
  getUserPermissions: async (userId) => {
    try {
      const response = await api.get(
        `${API_ENDPOINT_PREFIX}/${userId}/permissions`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 사용자 권한 설정
  setUserPermissions: async (userId, permissions) => {
    try {
      const response = await api.put(
        `${API_ENDPOINT_PREFIX}/${userId}/permissions`,
        {
          permissions,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default userAPI;
